import {useCallback, useEffect} from "react";

//import redux
import {useDispatch, useSelector} from "react-redux";
import {
  containerValueActions,
  editProjectNamedAction,
  getMyProject,
  selectCategoryAction,
  selectContainerAction,
  setServerSavedAction,
  updateContainerValue,
} from "../../features/sliceReducer/myProjectReducer";
import {RootState} from "../../features/store";

//import router-dom
import {Link, useNavigate} from "react-router-dom";

// material-UI
import {createStyles, makeStyles, Theme, withStyles} from "@material-ui/core/styles";

import {
  Box,
  Button,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";

//import component
import IPUtility from "../../classes/IPUtility";
import BreadCrumbsNav from "../../components/BreadCrumbsNav";
import ListTitle from "../../components/ListTitle";
import Loading from "../../components/Loading";
import ProgressBar from "../../components/ProgressBar";
import SkeletonTableCell from "../../components/SkeletonTableCell";
import {IPContainerValue} from "../../models/IPContainerValue";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      borderBottom: "1px solid grey",
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 20px 20px 20px",
      backgroundColor: theme.palette.custom.main,
    },
    table: {
      minWidth: 650,
      backgroundColor: theme.palette.gray.dark,
      // "& th, & td": {
      //   border: "1px solid rgba(224, 224, 224, 1)",
      // },
    },
    tableHead: {
      backgroundColor: theme.palette.gray.light,
    },
    buttonCell: {
      display: "flex",
      justifyContent: "space-around",
    },
    linkStyle: {
      color: theme.palette.primary.main,
      "&:hover": {
        color: theme.palette.primary.dark,
        textDecoration: "underLine",
      },
    },
  })
);

const MyProject = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    myProject,
    loading,
    myProjectTableHeader: tableHeader,
  } = useSelector((state: RootState) => state.myProject);
  const {currentUid} = useSelector((state: RootState) => state.projectList);
  const {userToken} = useSelector((state: RootState) => state.auth);

  const getProjectCallback = useCallback(() => {
    const localData = IPUtility.getLocalProjectInfo();
    if (localData.project.uid != currentUid && !localData.isSaveSuccessed) {
      const info =
        localData.date +
        "에 서버에 저장하지 못한 '" +
        localData.name +
        "'이 있습니다. 지금 이 프로젝트를 불러오면 해당 기록은 삭제됩니다.";
      if (window.confirm(info)) {
        dispatch(
          getMyProject({
            userToken,
            id: currentUid,
            successHandler: () => dispatch(setServerSavedAction(0)),
          })
        );
      } else {
        navigate(-1);
      }
    }
    if (myProject.uid !== currentUid) {
      dispatch(
        getMyProject({
          userToken,
          id: currentUid,
          successHandler: () => dispatch(setServerSavedAction(0)),
        })
      );
    }
  }, [currentUid]);

  useEffect(() => {
    getProjectCallback();
  }, [getProjectCallback]);

  const ExcludeChecked = (checked: boolean, containerValue: IPContainerValue) => {
    const containerValueX: IPContainerValue = {
      ...containerValue,
      isExclude: checked,
    };
    IPUtility.log(containerValueX);
    dispatch(updateContainerValue({userToken, item: containerValueX}));
    dispatch(containerValueActions(containerValueX));
  };

  return (
    <>
      <Loading loading={loading} />
      <ListTitle subTitle="My Project" buttonTitle="" />
      <Box className={classes.container}>
        <BreadCrumbsNav factory={myProject?.factoryName} project={myProject?.name} />
        <Box display="flex" justifyContent="space-between">
          <Box>
            <Button
              variant="contained"
              color="primary"
              startIcon={<DescriptionIcon />}
              onClick={() => {
                window.open(`/API/ExportSheet/${myProject.uid}?userToken=${userToken}`, "_blank");
              }}
            >
              Excel 저장하기
            </Button>
          </Box>
          <Box pl="16px">
            <Button
              variant="contained"
              color="secondary"
              startIcon={<DescriptionIcon />}
              onClick={() => {}}
            >
              Excel 불러오기
            </Button>
          </Box>
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead}>
            <TableRow>
              {tableHeader.map((headerTitle, index) => (
                <TableCell key={index} align="center">
                  {headerTitle}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <SkeletonTableCell row={9} column={6} />
            ) : (
              myProject.categories?.map((category, index1) =>
                category.containers.map((container, index2) => {
                  const rowSpan = category.containers.length;
                  const isExclude = container.containerValue?.isExclude;
                  if (index2 === 0) {
                    return (
                      <StyledTableRow key={container.uid}>
                        <TableCell
                          width="14%"
                          rowSpan={rowSpan}
                          align="center"
                          onClick={() => {
                            dispatch(
                              editProjectNamedAction({
                                category: category.name,
                                container: category.containers[0].name,
                              })
                            );
                            dispatch(selectCategoryAction(category.uid));
                            dispatch(selectContainerAction(category.containers[0].uid));
                          }}
                        >
                          <Link className={classes.linkStyle} to="/inspect/editProject">
                            {category.name}
                          </Link>
                        </TableCell>
                        <TableCell
                          width="22%"
                          align="center"
                          onClick={() => {
                            dispatch(
                              editProjectNamedAction({
                                category: category.name,
                                container: container.name,
                              })
                            );
                            dispatch(selectCategoryAction(category.uid));
                            dispatch(selectContainerAction(container.uid));
                          }}
                        >
                          <Link className={classes.linkStyle} to="/inspect/editProject">
                            {container.name}
                          </Link>
                        </TableCell>
                        <TableCell width="8%" align="center">
                          <Checkbox
                            defaultChecked={isExclude}
                            onChange={(e) =>
                              ExcludeChecked(e.target.checked, container.containerValue)
                            }
                          />
                        </TableCell>
                        <TableCell width="8%" align="center">
                          {IPUtility.getContainerPoint(myProject, container)}/
                          {IPUtility.getContainerAssignedPoints(myProject, container.uid)}
                        </TableCell>
                        <TableCell align="center" width="25%">
                          <ProgressBar
                            color="primary"
                            count={IPUtility.getTotalFilledCount(myProject, container)}
                            total={IPUtility.getItemLength(myProject, container)}
                            totalPercentage={Math.round(
                              (IPUtility.getTotalFilledCount(myProject, container) /
                                IPUtility.getItemLength(myProject, container)) *
                                100
                            )}
                          />
                        </TableCell>
                        <TableCell align="center" width="25%">
                          <ProgressBar
                            color="secondary"
                            count={IPUtility.getMyFilledCount(myProject, container)}
                            total={IPUtility.getItemLength(myProject, container)}
                            totalPercentage={Math.round(
                              (IPUtility.getMyFilledCount(myProject, container) /
                                IPUtility.getItemLength(myProject, container)) *
                                100
                            )}
                          />
                        </TableCell>
                      </StyledTableRow>
                    );
                  } else {
                    return (
                      <StyledTableRow key={container.uid}>
                        <TableCell
                          align="center"
                          onClick={() => {
                            dispatch(
                              editProjectNamedAction({
                                category: category.name,
                                container: container.name,
                              })
                            );
                            dispatch(selectCategoryAction(category.uid));
                            dispatch(selectContainerAction(container.uid));
                          }}
                        >
                          <Link className={classes.linkStyle} to="/inspect/editProject">
                            {container.name}
                          </Link>
                        </TableCell>
                        <TableCell width="8%" align="center">
                          <Checkbox
                            defaultChecked={isExclude}
                            onChange={(e) =>
                              ExcludeChecked(e.target.checked, container.containerValue)
                            }
                          />
                        </TableCell>
                        <TableCell width="8%" align="center">
                          {IPUtility.getContainerPoint(myProject, container)}/
                          {IPUtility.getContainerAssignedPoints(myProject, container.uid)}
                        </TableCell>
                        <TableCell align="center" width="25%">
                          <ProgressBar
                            color="primary"
                            count={IPUtility.getTotalFilledCount(myProject, container)}
                            total={IPUtility.getItemLength(myProject, container)}
                            totalPercentage={Math.round(
                              (IPUtility.getTotalFilledCount(myProject, container) /
                                IPUtility.getItemLength(myProject, container)) *
                                100
                            )}
                          />
                        </TableCell>
                        <TableCell align="center" width="25%">
                          <ProgressBar
                            color="secondary"
                            count={IPUtility.getMyFilledCount(myProject, container)}
                            total={IPUtility.getItemLength(myProject, container)}
                            totalPercentage={Math.round(
                              (IPUtility.getMyFilledCount(myProject, container) /
                                IPUtility.getItemLength(myProject, container)) *
                                100
                            )}
                          />
                        </TableCell>
                      </StyledTableRow>
                    );
                  }
                })
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default MyProject;
